import styled, { css } from 'styled-components';

import { Direction } from './HorizontalScrollerNavigation.types';
import { directionSelector } from './HorizontalScrollerNavigation.utils';

type StyledHorizontalScrollerNavigationContainerProps = {
   $direction: Direction;
   $visible: boolean;
};

export const StyledHorizontalScrollerNavigationContainer = styled.div<StyledHorizontalScrollerNavigationContainerProps>`
   width: 60px;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;

   position: absolute;
   isolation: isolate;
   pointer-events: none;

   transition: opacity 0.2s ease;

   ${(props) => {
      const byDirection = directionSelector(props.$direction);

      return css`
         ${byDirection('left', 'right')}: 0;
         background: linear-gradient(to ${byDirection('right', 'left')}, ${props.theme.backgroundBody}, transparent);
         opacity: ${props.$visible ? '1' : '0'};
      `;
   }}
`;

StyledHorizontalScrollerNavigationContainer.displayName = 'StyledHorizontalScrollerNavigationContainer';

type StyledHorizontalScrollerNavigationButtonProps = {
   $visible: boolean;
};

export const StyledHorizontalScrollerNavigationButton = styled.button<StyledHorizontalScrollerNavigationButtonProps>`
   border-radius: 16px;
   border: none;
   outline: none;
   display: flex;
   justify-content: center;
   align-items: center;
   height: 32px;
   width: 32px;

   & > svg {
      width: 32px;
      height: 32px;
      flex: 0 0 auto;
   }

   ${(props) => css`
      background-color: ${props.theme.backgroundLightest};
      fill: ${props.theme.primary};
      pointer-events: ${props.$visible ? 'all' : 'none'};

      &:hover {
         fill: ${props.theme.primaryDark};
         cursor: pointer;
      }
   `}
`;

StyledHorizontalScrollerNavigationButton.displayName = 'StyledHorizontalScrollerNavigationButton';
